import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ChatbotPanelComponent } from './components/chatbot-panel/chatbot-panel.component';

const routes: Routes = [
  {
    path: '',
    children: [
      { path: '', component: ChatbotPanelComponent },
      { path: '**', redirectTo: '' },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
/**
 * Módulo de enrutamiento del chatbot.
 *
 * Define la ruta hija raíz que renderiza el panel del chatbot y redirige
 * cualquier ruta no reconocida hacia esa ruta por defecto.
 */
export class ChatbotRoutingModule { }
